// Dates manipulées en chaînes ISO "YYYY-MM-DD" (heure locale), format
// utilisé par le contrôleur ajax de seq_magasins.
function pad(n) {
  return n < 10 ? "0" + n : "" + n;
}

export function toIso(date) {
  return (
    date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate())
  );
}

export function fromIso(iso) {
  const parts = iso.substr(0, 10).split("-");
  return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
}

// "2026-10-17" -> "2026-10-01"
export function monthOf(iso) {
  return iso.substr(0, 7) + "-01";
}

export function addMonths(monthIso, delta) {
  const date = fromIso(monthIso);
  return toIso(new Date(date.getFullYear(), date.getMonth() + delta, 1));
}
